import Phonsesthree from "../Detials/phonesthree";
import Othertwo from "../Detials/othertwo"



function Rowtwo(){
    return(
        <>
        <Phonsesthree/>
        <Othertwo/>

        </>
    )
}
export default Rowtwo